import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const connectionWizard: ThemeApp['appComponents']['connectionWizard'] = {
  components: {
    connectionWizard: {
      codeSnippetBox: {
        border: themeUi.semantic.color.border.secondary800,
        color: themeUi.semantic.color.text.secondary50
      },
      codeSnippetBoxContent: {
        fontFamily: themeUi.core.font.fontFamily.sourceCodeProRegular
      },
      highlightedPlaceholder: {
        color: themeUi.semantic.color.text.notice500
      },
      highlightedPlaceholderSecondary: {
        color: themeUi.semantic.color.text.primary300
      },
      highlightedEndpoint: {
        color: themeUi.semantic.color.text.success500
      },
      selectTrigger: {
        backgroundColor: themeUi.semantic.color.background.primary300
      },
      selectTriggerValue: {
        color: themeUi.semantic.color.text.primary300
      },
      label: {
        color: themeUi.semantic.color.text.secondary50
      }
    },

    connectionWizardCli: {
      separator: {
        backgroundColor: themeUi.semantic.color.background.neutral400
      }
    },

    connectionWizardClient: {
      separator: {
        backgroundColor: themeUi.semantic.color.background.secondary800
      }
    },

    copySnippet: {
      label: {
        color: themeUi.semantic.color.text.success500
      }
    },

    redisInsightConnection: {
      explanationHeader: {
        color: themeUi.semantic.color.text.secondary50
      },
      actionButtons: {
        borderTop: themeUi.semantic.color.border.neutral400
      }
    },

    setupConnectionMethod: {
      title: {
        color: themeUi.semantic.color.text.secondary50
      },
      description: {
        color: themeUi.semantic.color.text.secondary300
      }
    }
  }
};
